import React from 'react';

import { FormControlLabel, Radio, RadioGroup, Paper } from '@material-ui/core';
import MaterialTable from 'material-table';
import file from '../../../assets/excelFile.svg'

import commonStyles from '../../common/common.module.css';
import styles from '../analytics.module.css';


interface ShipmentDataProps {
  shipmentCol: any;
  shipmentData: any;
  ship_type: string;
  handleChange: (type: string, event: any) => void;
  handleExport: (type: string) => void;
};

const ShipmentData = (props: ShipmentDataProps) => {
  return (
    <div className={`${styles.wtOuterGridItems}`}>
      <div className={`${commonStyles.fSpaceBtw} ${commonStyles.flexWrap} ${commonStyles.mb4}`}>
        <h5 className={styles.heading}>Shipment Data</h5>
        <RadioGroup
          row
          aria-label="Shipment Data"
          name="Shipment Data"
          className={`${styles.tcRadioGroup}`}>
          <FormControlLabel
            checked={props.ship_type == 'ALL' ? true : false}
            onClick={() => {
              props.handleChange('ship_type', 'ALL');
            }}
            control={
              <Radio
                value="ALL"
                color="primary"
                size="small"
              />
            }
            label="All Shipment Data"
            className={styles.carrierRadio}
          />
          <FormControlLabel
            checked={props.ship_type == 'AWB' ? true : false}
            onClick={() => {
              props.handleChange('ship_type', 'AWB');
            }}
            control={
              <Radio
                value="AWB"
                color="primary"
                size="small"
              />
            }
            label="Shipment Irregurality List"
            className={styles.carrierRadio}
          />
          <FormControlLabel
            checked={props.ship_type == 'CUSTOMER' ? true : false}
            onClick={() => {
              props.handleChange('ship_type', 'CUSTOMER');
            }}
            control={
              <Radio
                value="CUSTOMER"
                color="primary"
                size="small"
              />
            }
            label="Customer Error List"
            className={styles.carrierRadio}
          />
        </RadioGroup>
        <div className={`${styles.fileImg}`}>
          <img src={file} alt="file" onClick={()=> props.handleExport('shipment')} />
        </div>
      </div>
      <MaterialTable
        components={{ Container: props => <Paper {...props} elevation={0} className={`${commonStyles.paperTable} ${styles.anayTable}`} /> }}
        data={ props.shipmentData }
        columns={ props.shipmentCol }
        options={{
          paging: props.shipmentData.length > 10,
          pageSize: 10,
          headerStyle: {
            backgroundColor: 'var(--tbl_head_bkg)',
            color: 'var(--tbl_head_color)',
            zIndex: 2,
            textAlign: 'center',
            fontWeight: 600,
          },
          maxBodyHeight: '400px',
          showTitle: false,
          pageSizeOptions: [15, 20],
          toolbar: false,
          sorting: false
        }}
      />
    </div>
  );
};

export default ShipmentData;